export { MAX_CAROUSEL_RECENTLY_VIEWED_ITEMS } from '../src/recentHistoryConstants';
